import { postData, getData } from "../common/Apicall";

export const userProfileDetailsApi = (uid) => {
  return postData("/api/v1/users/getUserDetails", { uid });
};

export const updateProfileDetailsApi = (uid) => {
  return postData("/api/v1/users/updateUserDetails", { uid });
};

export const storeDetailsAPI = (storeID) => {
  return postData("/api/v1/store/getStoreDetails", { storeID });
};

export const buyerOverviewAPI = (uid) => {
  return getData("/api/v1/users/getBuyerOverview", { uid });
};

export const getAccountTypeApi = () => {
  return postData("/api/v1/users/getAccountType");
};
